controllers.controller('KycCheckController', [
    '$scope', '$state', '$ionicLoading', 'LocaleService', 'UserService', 'AccountService',
    'Utils', 'Storage', 'constants',
    function ($scope, $state, $ionicLoading, LocaleService, UserService, AccountService,
              Utils, Storage, Const) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
            $scope.showKycModal();
        });

        $scope.message = '';

        $scope.onNext = function () {
            var vProvider = Const['verificationProvider'];
            var verificationStatePath = (!vProvider || vProvider === 'internal') ? 'root.app.uploadDocuments' :
                                        (vProvider === 'internal-v2') ? 'root.app.verification-v2' :
                                        (vProvider === 'sumsub') ? 'root.app.verificationSumsub' : '';

            if (!verificationStatePath) {
                console.warn('Unknown verification provider');
                return;
            }
            return $state.go(verificationStatePath, {cache: false});
        };

        $scope.onCancel = function () {
            return $state.go('root.app.assets', {cache: false})
        };
        $scope.showKycModal = function () {
            var user = UserService.get();
            var userName = user.firstName + ' ' + user.lastName;
            var messageKey = user.complianceStatusNegative ? 'compliance_status_negative' : 'compliance_status_positive';
            $scope.message = ($scope.translation[messageKey] || '').replace(/\%name\%/, userName);
        };

    }]);
